import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface CustomModalProps {
  title: string | undefined;
  content?: React.ReactNode;
  onSubmit?: () => void;
  onSubmitCustomDisplay?: string;
  onCancel?: () => void;
  modalSize?: 'sm' | 'lg' | 'xl' | undefined;
  hasCustomButtons?: boolean;
}

// Define a custom type for the modal ref that exposes show and hide methods
export interface ModalHandle {
  show: () => void;
  hide: () => void;
}

export enum ModalWidth {
  narrow = 'narrow',
  wide = 'wide'
}

// Use React.forwardRef to correctly handle refs with ModalHandle type
const CustomModal = React.forwardRef<ModalHandle, CustomModalProps>(
  (
    {
      title,
      content,
      onSubmit,
      onCancel,
      onSubmitCustomDisplay,
      hasCustomButtons,
      modalSize
    },
    ref
  ) => {
    const [show, setShow] = React.useState(false);

    // Expose show and hide methods to the parent component
    React.useImperativeHandle(ref, () => ({
      show: () => setShow(true),
      hide: () => setShow(false)
    }));

    const handleClose = () => setShow(false);

    return (
      <>
        <Modal size={modalSize} show={show} onHide={handleClose} centered>
          <Modal.Dialog className="m-0">
            <Modal.Header closeButton>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{content}</Modal.Body>
            {hasCustomButtons ? (
              <></>
            ) : (
              <Modal.Footer>
                <Button variant="secondary" onClick={onCancel || handleClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={onSubmit || handleClose}>
                  {onSubmitCustomDisplay ? onSubmitCustomDisplay : 'Submit'}
                </Button>
              </Modal.Footer>
            )}
          </Modal.Dialog>
        </Modal>
      </>
    );
  }
);

export default CustomModal;
